"use client";
import { GoBellFill } from "react-icons/go";
import { useNotificationStore } from "@shared/src/stores/useNotificationStore";
import { cn } from "@shared/src/utils/cn";

export function NotificationIcon({ className }: { className?: string }) {
  const { hasNotification: hasUnreadNotifications } = useNotificationStore();
  return (
    <div className={cn("relative", className)}>
      <GoBellFill size={20} />
      {hasUnreadNotifications && <div className="absolute -top-1 right-0 size-1.5 bg-primary-600 rounded-full" />}
    </div>
  );
}
